import styled from "styled-components";

export const WrapperBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid ${({ theme }) => theme.pallette.silver.secondary};

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 40px;
  }
`;

export const Copyright = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.silver.primary};
`;

export const Version = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.pallette.blue.primary};
`;
